/**
 * @description 滚动提示
 * @params contentRef 滚动dom
 * @return scrollImgDom
 */

import React, { useState, useEffect } from 'react'
import scrollImg from './scroll.png'
import s from './index.module.less'

function useScrollTips(contentRef: React.RefObject<HTMLDivElement>) {
  // 滚动提示
  const [scrollHint, setScrollHint] = useState(true)

  useEffect(() => {
    if (!scrollHint) {
      // 如果已经隐藏了，就不需要监听了
      return
    }

    const handleScroll = () => {
      setScrollHint(false)
    }

    let isCleanedUp = false
    let intervalId: number | null = null

    // 轮询检查DOM元素是否已经挂载
    const checkAndAddListener = () => {
      if (isCleanedUp) {
        return false // 如果已经清理，直接返回
      }

      const element = contentRef.current
      if (element) {
        // DOM元素已经挂载，添加滚动监听器
        element.addEventListener('scroll', handleScroll, { passive: true })
        if (intervalId) {
          clearInterval(intervalId)
          intervalId = null
        }
        return true
      }
      return false
    }

    // 立即检查一次
    if (!checkAndAddListener()) {
      // 如果元素还没有挂载，开始轮询检查
      intervalId = window.setInterval(() => {
        if (checkAndAddListener()) {
          // 找到元素后停止轮询
          if (intervalId) {
            clearInterval(intervalId)
            intervalId = null
          }
        }
      }, 50) // 每50ms检查一次
    }

    // eslint-disable-next-line consistent-return
    return () => {
      isCleanedUp = true
      if (intervalId) {
        clearInterval(intervalId)
      }
      // 清理可能已经添加的事件监听器
      const element = contentRef.current
      if (element) {
        element.removeEventListener('scroll', handleScroll)
      }
    }
  }, [scrollHint])

  // 滚动提示dom
  const scrollImgDom = () => {
    return scrollHint ? <img src={scrollImg} alt="下拉滚动提示" className={s.scrollTips} /> : null
  }

  return scrollImgDom
}

export default useScrollTips
